export default __webpack_public_path__ + "static/media/dora-dialyzer.9fe69bea.jpg";